<template>
  <section id="politicaDePrivacidad">
    <div id="bloqueSuperior">
      <div id="bloqueSuperior__texto">
        <p id="bloqueSuperior__texto--privacidad">PRIVACIDAD</p>
        <p id="bloqueSuperior__texto--descripcion">
          Aquí encontrarás cómo gestionamos el tratamiento de datos personales.
        </p>
      </div>
    </div>
    <div id="Privacidad" class="modal-content">

      <div class="divModalInterno">
        <p class="textoCentradoModal">
          <strong class="fontBold"
            ><u>POL&Iacute;TICA DE PRIVACIDAD Y COOKIES&nbsp;</u></strong
          >
        </p>
        <p>
          <strong class="fontBold">1. &iquest;QUI&Eacute;NES SOMOS?</strong>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Nosotros somos Alebat Education, S.L. y tratamos tus datos personales
          como responsable del tratamiento.
        </p>
        <p>
          <strong class="fontBold"
            >2. &iquest;PARA QU&Eacute; USAMOS TUS DATOS?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Usaremos tus datos (obtenidos online, telef&oacute;nicamente o en
          persona), entre otras finalidades, para gestionar la
          contrataci&oacute;n de servicios o compra de productos, gestionar tu
          registro como usuario, atender tus consultas, as&iacute; como para, en
          caso de que lo desees, enviarte nuestras comunicaciones
          personalizadas.
        </p>
        <p>
          <strong class="fontBold"
            >3. &iquest;POR QU&Eacute; LOS USAMOS?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Estamos legitimados para tratar tus datos por diferentes motivos. El
          principal, es que necesitamos tratarlos para ejecutar el contrato que
          aceptas con nosotros al contratar nuestros servicios o funcionalidades
          y registrarte. Tambi&eacute;n usamos tus datos por otras razones, por
          ejemplo, para atender tus consultas o para enviarte newsletters que
          nos has solicitado recibir.
        </p>
        <p>
          <strong class="fontBold"
            >4. &iquest;CON QUI&Eacute;N COMPARTIMOS TUS DATOS?
          </strong>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Compartiremos tus datos con prestadores de servicios que nos ayudan o
          dan soporte, ya sean empresas del propio Grupo AE o colaboradores
          externos con quien hemos firmado el correspondiente contrato de
          encargo de tratamiento de datos personales.
        </p>
        <p><strong class="fontBold">5. TUS DERECHOS.</strong></p>
        <p class="fontBook" style="padding-left: 40px">
          Tienes derecho a acceso, rectificaci&oacute;n, cancelaci&oacute;n,
          oposici&oacute;n portabilidad y limitaci&oacute;n de sus datos,
          as&iacute; como el derecho a retirar el consentimiento prestado en
          cualquier momento, como te explicamos en detalle m&aacute;s abajo.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Te invitamos a leer nuestra Pol&iacute;tica de Privacidad y Cookies
          completa a continuaci&oacute;n para entender en detalle el uso que
          haremos de tus datos personales y los derechos de los que dispones en
          relaci&oacute;n con los mismos.
        </p>
        <p class="clickVerMas fontBold"><u>VER M&Aacute;S</u></p>

        <div class="divVerMas">
          <p class="textoCentradoModal">
            <strong class="fontBold"
              ><u>SEGUNDA CAPA DE INFORMACI&Oacute;N</u></strong
            >
          </p>
          <ul>
            <li style="list-style-type: none">
              <ul>
                <li class="fontBook">
                  En esta Pol&iacute;tica de Privacidad y Cookies
                  encontrar&aacute;s toda la informaci&oacute;n relevante que
                  aplica al uso que hacemos de los datos personales de nuestros
                  clientes y usuarios, con independencia del canal o medio
                  (online, telef&oacute;nico o en persona) que utilices para
                  interactuar con nosotros.
                </li>
                <li class="fontBook">
                  Si deseas informaci&oacute;n sobre c&oacute;mo utilizamos las
                  cookies y otros dispositivos similares que puedan estar
                  instalados en los terminales de nuestros clientes y usuarios,
                  te recomendamos que consultes la
                  <strong
                    ><u class="mostrarCookies dentroDePrivacidad"
                      >Pol&iacute;tica de Cookies<strong class="fontBold"
                        ><u>.</u></strong
                      >
                    </u></strong
                  >
                </li>
                <li class="fontBook">
                  Somos transparentes sobre lo que hacemos con tus datos
                  personales, para que entiendas las implicaciones de los usos
                  que llevamos a cabo o los derechos de los que dispones en
                  relaci&oacute;n con tus datos: o Ponemos a tu
                  disposici&oacute;n de forma permanente toda la
                  informaci&oacute;n en esta Pol&iacute;tica de Privacidad y
                  Cookies que puedes consultar cuando lo estimes oportuno y
                  adem&aacute;s, o tambi&eacute;n ir&aacute;s encontrando
                  informaci&oacute;n acerca de cada tratamiento de tus datos
                  personales conforme vayas interactuando con nosotros.
                </li>
                <li class="fontBook">
                  Algunos nombres que usaremos en esta Pol&iacute;tica de
                  Privacidad y Cookies:
                </li>
              </ul>
            </li>
          </ul>
          <p class="fontBook" style="padding-left: 40px">
            o Cuando hablamos de nuestra Web, nos referiremos en general a
            cualquiera de los canales o medios digitales, telef&oacute;nicos o
            en persona que hayas utilizado para interactuar con nosotros. Los
            principales son:
          </p>
          <ul>
            <li style="list-style-type: none">
              <ul>
                <li class="fontBook">
                  Nuestra Web. (<a class="enlace" href="http://www.alebateducation.com/"
                    >alebateducation.com </a
                  >)
                </li>
                <li class="fontBook">
                  Telef&oacute;nicamente (<a class="enlace" href="tel:+34918336967"
                    >918 33 69 67</a
                  >), en grabaciones que podamos ejecutar
                </li>
                <li class="fontBook">En persona, en nuestra sede.</li>
              </ul>
            </li>
          </ul>
          <p class="fontBook">
            <strong class="fontBold"
              >1. &iquest;QUI&Eacute;N ES EL RESPONSABLE DEL TRATAMIENTO DE TUS
              DATOS?</strong
            >
          </p>
          <p class="fontBook" style="padding-left: 40px">
            <strong class="fontBold">Responsable del tratamiento:</strong>
            ALEBAT EDUCATION, S.L., sociedad que actualmente opera en
            Espa&ntilde;a la venta de productos de formaci&oacute;n integrados
            en la marca AE (en adelante AE).
          </p>
          <p class="fontBook" style="padding-left: 40px">
            <strong class="fontBold">CIF: </strong>B87437018
          </p>
          <p class="fontBook" style="padding-left: 40px">
            <strong class="fontBold">Domicilio Social:</strong> Club Deportivo
            1, Edif, 4,1&ordf;, 28223, Pozuelo de Alarc&oacute;n (Madrid)
          </p>
          <p class="fontBook" style="padding-left: 40px">
            <strong class="fontBold">Direcci&oacute;n postal:</strong> C/ Mayor
            de Fontenebro 238, 28400, Collado Villalba, Madrid, Espa&ntilde;a.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            <strong class="fontBold"
              >Correo electr&oacute;nico del Departamento de Protecci&oacute;n
              de Datos: </strong
            ><a class="enlace" href="mailto:CDPD@alebateducation.com"
              >CDPD@alebateducation.com</a
            >
          </p>
          <strong class="fontBold"
            >2. &iquest;CON QU&Eacute; FINALIDAD TRATAMOS TUS DATOS
            PERSONALES?</strong
          >
          <p class="fontBook" style="padding-left: 40px">
            Dependiendo de los servicios, funcionalidades o productos de los que
            quieras disfrutar en cada momento necesitaremos tratar unos datos u
            otros, que en general ser&aacute;n, seg&uacute;n el caso, los
            siguientes:
          </p>
          <ol>
            <li style="list-style-type: none">
              <ol class="lista">
                <li class="fontBook">
                  tus datos identificativos (por ejemplo, tu nombre, apellido,
                  imagen, idioma y pa&iacute;s desde el que interact&uacute;as
                  con nosotros, datos de contacto (tel&eacute;fono y email),
                  etc.)
                </li>
                <li class="fontBook">
                  gestionar la solicitud de informaci&oacute;n y mantenerte
                  informado de los cursos, productos y servicios del Grupo AE
                  que ofrecemos (programas m&aacute;ster, cursos, seminarios y
                  libros, principalmente).
                </li>
                <li class="fontBook">
                  datos de conexi&oacute;n, geolocalizaci&oacute;n y
                  navegaci&oacute;n (por ejemplo, los datos de
                  localizaci&oacute;n, el n&uacute;mero de identificaci&oacute;n
                  del dispositivo o el ID de publicidad) y informaci&oacute;n
                  comercial (por ejemplo, si est&aacute;s suscrito a nuestra
                  newsletter).
                </li>
              </ol>
            </li>
          </ol>
          <p class="fontBook" style="padding-left: 40px">
            Recuerda que, cuando te pidamos que rellenes tus datos personales
            para darte acceso a alguna funcionalidad o servicio, marcaremos
            algunos campos como obligatorios, puesto que son datos que
            necesitamos para poder prestarte el servicio o darte acceso a la
            funcionalidad en cuesti&oacute;n. Por favor, ten en cuenta que, si
            decides no facilitarnos esos datos, es posible que no puedas
            completar tu registro como usuario o que no puedas disfrutar de esos
            servicios o funcionalidades.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            En otros casos, podemos obtener informaci&oacute;n de forma pasiva
            al utilizar herramientas de rastreo, como las cookies de los
            navegadores u otras tecnolog&iacute;as similares de nuestra Web o de
            las comunicaciones que te enviamos. En determinados casos, un
            tercero puede habernos facilitado informaci&oacute;n sobre ti al
            contratar un servicio para que t&uacute; lo disfrutes. En tales
            casos, &uacute;nicamente trataremos tus datos en relaci&oacute;n con
            esa funcionalidad o servicio, de conformidad con lo establecido en
            la presente Pol&iacute;tica de Privacidad y Cookies.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Dependiendo de c&oacute;mo interact&uacute;es con nuestra Web,
            trataremos tus datos personales para las siguientes finalidades:
          </p>
          <table border="">
            <tbody>
              <tr>
                <td>
                  <p class="textoCentradoModal">
                    <strong class="fontBold">FINALIDAD</strong>
                  </p>
                </td>
                <td>
                  <p class="textoCentradoModal">
                    <strong class="fontBold">+ INFO</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong
                      >1. Para gestionar tu registro como usuario de la Web de
                      Cursos de AE</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    En caso de apuntarte a un curso de la AE deber&aacute;s
                    registrarte como usuario en nuestra Web, y necesitamos
                    tratar tus datos para identificarte como usuario de la misma
                    y darte acceso a sus diferentes funcionalidades, productos y
                    servicios que est&aacute;n a tu disposici&oacute;n como
                    usuario registrado. Puedes cancelar tu cuenta de usuario
                    registrado contactando con nosotros a trav&eacute;s de los
                    datos indicados en el apartado primero. Te informamos de que
                    los datos que recopilamos sobre tu actividad, obtenidos a
                    trav&eacute;s de los diferentes canales de la Web, y que
                    incluyen los servicios contratados, permanecer&aacute;n
                    vinculados a tu cuenta para que se pueda acceder a toda la
                    informaci&oacute;n de una vez.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong
                      >2. Para el desarrollo, cumplimiento y ejecuci&oacute;n
                      del contrato de servicios que hayas contratado con
                      Nosotros en la Web</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Esta finalidad incluye el tratamiento de tus datos para,
                    principalmente:
                  </p>
                  <ol class="lista">
                    <li class="fontBook">
                      Contactar contigo en relaci&oacute;n a actualizaciones o
                      comunicaciones informativas relacionadas con las
                      funcionalidades, productos o servicios contratados,
                      incluyendo el env&iacute;o de encuestas de calidad sobre
                      los productos o servicios prestados.
                    </li>
                    <li class="fontBook">
                      Gestionar el pago de los productos que contrates,
                      independientemente del medio de pago utilizado.
                    </li>
                    <li class="fontBook">
                      Activar los mecanismos necesarios con objeto de prevenir y
                      detectar el uso indebido de la Web, por ejemplo, durante
                      el proceso de contrataci&oacute;n o conexi&oacute;n,
                      as&iacute; como potenciales fraudes contra ti y/o contra
                      Nosotros. Si consideramos que la operaci&oacute;n puede
                      ser fraudulenta o detectamos comportamientos anormales con
                      indicios de tratarse de usos fraudulentos de nuestras
                      funcionalidades, productos y servicios, este tratamiento
                      puede tener consecuencias como el bloqueo de la
                      transacci&oacute;n o la cancelaci&oacute;n de tu cuenta de
                      usuario.
                    </li>
                    <li class="fontBook">
                      Gestionar posibles cambios o modificaciones de cursos una
                      vez hayas realizado una contrataci&oacute;n y gestionar
                      solicitudes de informaci&oacute;n sobre la disponibilidad
                      de cursos, reservas de productos a trav&eacute;s de la
                      Web, seg&uacute;n dichas opciones se encuentren
                      disponibles en cada momento.
                    </li>
                    <li class="fontBook">
                      Con fines de facturaci&oacute;n y para poner a tu
                      disposici&oacute;n los tickets y facturas de las compras
                      que hayas realizado en la Web.
                    </li>
                  </ol>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong
                      >3. Para atender las solicitudes o peticiones que realices
                      a Atenci&oacute;n al Cliente</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    S&oacute;lo tratamos los datos personales que sean
                    estrictamente necesarios para gestionar o resolver tu
                    solicitud o petici&oacute;n. Si utilizas el canal
                    telef&oacute;nico, la llamada puede ser grabada para atender
                    tu petici&oacute;n y garantizar la calidad de la misma. Si
                    est&aacute; disponible, y decides comunicarte con nosotros a
                    trav&eacute;s del servicio de chat de una red social u otro
                    colaborador, algunos de tus datos, como tu nombre o nombre
                    de usuario, se importar&aacute;n desde tu cuenta de la red
                    social o del colaborador. Asimismo, debes tener en cuenta
                    que los datos que introduzcas en este servicio
                    estar&aacute;n disponibles para tu red social o colaborador
                    y quedar&aacute;n sujetos a sus correspondientes
                    pol&iacute;ticas de privacidad. As&iacute; pues, te
                    recomendamos que revises tu configuraci&oacute;n de
                    privacidad y leas la pol&iacute;tica de privacidad de la red
                    social o colaborador para obtener informaci&oacute;n
                    detallada sobre el uso que hacen de tus datos personales al
                    utilizar sus servicios
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold"
                      >4. Para fines de marketing
                    </strong>
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Esta finalidad incluye el tratamiento de tus datos para,
                    principalmente:
                  </p>
                  <ol class="lista">
                    <li class="fontBook">
                      Personalizar los servicios que te ofrecemos y poder
                      hacerte recomendaciones en funci&oacute;n de tu
                      interacci&oacute;n con nosotros en la Web y del
                      an&aacute;lisis de tu perfil de usuario (por ejemplo, en
                      base a tu historial de compra y navegaci&oacute;n).
                    </li>
                    <li class="fontBook">
                      En la medida en que te suscribas a nuestra Newsletter,
                      trataremos tus datos personales para gestionar tu
                      suscripci&oacute;n, incluyendo el env&iacute;o de
                      informaci&oacute;n personalizada acerca de nuestros
                      productos o servicios a trav&eacute;s de diversos medios
                      (como el correo electr&oacute;nico o SMS). As&iacute;
                      mismo, podremos hacerte llegar esta informaci&oacute;n a
                      trav&eacute;s de notificaciones push en el caso de que las
                      haya activado en tu dispositivo.
                    </li>
                    <li class="fontBook">
                      Por tanto, ten en cuenta que este tratamiento de datos
                      conlleva el an&aacute;lisis de tu perfil de usuario o
                      cliente para determinar cu&aacute;les son tus preferencias
                      y por tanto cu&aacute;les pueden ser los productos y
                      servicios que m&aacute;s encajan con tu estilo a la hora
                      de enviarte informaci&oacute;n. Por ejemplo, en base a tu
                      historial de compra y navegaci&oacute;n (a saber, en
                      funci&oacute;n de los cursos sobre las que hayas hecho
                      click), te haremos sugerencias acerca de productos que
                      creemos que pueden interesarte y, si eres usuario
                      registrado, te facilitaremos la funcionalidad de
                      "recuperaci&oacute;n de carrito"
                    </li>
                    <li class="fontBook">
                      . Recuerda que puedes darte de baja de la Newsletter en
                      cualquier momento y sin coste alguno contactando con
                      nosotras a info@alebateducation.com.
                    </li>
                    <li class="fontBook">
                      Mostrarte publicidad en Internet que podr&aacute;s ver
                      cuando navegues en sitios web y apps, por ejemplo, en
                      redes sociales. La publicidad que veas puede mostrarse de
                      modo aleatorio, pero en otras ocasiones se trata de
                      publicidad que puede estar relacionada con tu historial de
                      compra, preferencias y navegaci&oacute;n.
                    </li>
                    <li class="fontBook">
                      En caso de que seas usuario de redes sociales, podremos
                      facilitarles a aquellas con las que colaboremos
                      determinada informaci&oacute;n para que puedan mostrarte
                      anuncios de nuestra marca y, en general, ofrecerte a ti o
                      a otros usuarios similares, publicidad teniendo en cuenta
                      tu perfil en dichas redes sociales. Si quieres
                      informaci&oacute;n sobre el uso de tus datos y el
                      funcionamiento de anuncios en estas redes sociales, te
                      recomendamos que revises la informaci&oacute;n acerca de
                      tu privacidad en las redes sociales en las que participas.
                    </li>
                    <li class="fontBook">
                      Adicionalmente utilizamos tus datos para llevar a cabo
                      an&aacute;lisis de medici&oacute;n y segmentaci&oacute;n
                      de los anuncios que mostramos a los usuarios en algunas
                      Webs de colaboradores. Para ello colaboramos con estos
                      terceros que nos ofrecen la tecnolog&iacute;a necesaria
                      (por ejemplo, a trav&eacute;s de cookies, p&iacute;xeles,
                      SDK) para utilizar estos servicios. Ten en cuenta que, si
                      bien no facilitamos datos personales identificativos a
                      estos colaboradores, les comunicamos alg&uacute;n
                      identificador &uacute;nico (por ejemplo, el identificador
                      de publicidad asociado al dispositivo, identificador de
                      alguna cookie, etc). Si quieres m&aacute;s
                      informaci&oacute;n al respecto, por favor, revisa nuestra
                      Pol&iacute;tica de Cookies. As&iacute; mismo, puedes
                      restablecer tu identificador de publicidad o deshabilitar
                      la personalizaci&oacute;n de los anuncios en tu
                      dispositivo modificando tus preferencias en la
                    </li>
                    <li class="fontBook">
                      Enriquecimiento de datos: Cuando obtengamos tus datos
                      personales de diversas fuentes, podremos combinarlos en
                      determinadas circunstancias con el fin de mejorar nuestra
                      comprensi&oacute;n de tus necesidades y preferencias en
                      relaci&oacute;n con nuestros productos y servicios
                      (incluidas las finalidades de an&aacute;lisis,
                      generaci&oacute;n de perfiles de uso, estudios de
                      marketing, encuestas de calidad y mejora de la
                      interacci&oacute;n con nuestros clientes). Nos referimos,
                      por ejemplo, a la combinaci&oacute;n de informaci&oacute;n
                      que podemos hacer si tienes una cuenta registrada y, con
                      la misma direcci&oacute;n de correo electr&oacute;nico que
                      la vinculada a tu cuenta, realizas compras como invitado;
                      o a informaci&oacute;n recopilada autom&aacute;ticamente
                      (como direcciones IP, MAC o metadatos) que podemos
                      vincular con aquella informaci&oacute;n que nos hayas
                      proporcionado directamente a trav&eacute;s de tu actividad
                      en la Web o en cualquiera de nuestras tiendas (por
                      ejemplo, la informaci&oacute;n relacionada con tus
                      compras, ya sea en tiendas f&iacute;sicas o en la tienda
                      online, tus preferencias).
                    </li>
                    <li class="fontBook">
                      Llevar a cabo acciones promocionales. Al participar en
                      alguna acci&oacute;n promocional, nos autorizas a que
                      tratemos los datos que nos facilites en funci&oacute;n de
                      cada acci&oacute;n promocional y los podamos comunicar a
                      trav&eacute;s de diversos medios como redes sociales o en
                      la propia Web. En cada acci&oacute;n promocional en la que
                      participes tendr&aacute;s disponibles las bases legales
                      donde te facilitaremos informaci&oacute;n m&aacute;s
                      detallada sobre el tratamiento de tus datos.
                    </li>
                    <li class="fontBook">
                      Difundir en la Web o a trav&eacute;s de nuestros canales
                      en las redes sociales fotograf&iacute;as o im&aacute;genes
                      que hayas compartido de forma p&uacute;blica, siempre que
                      nos des tu consentimiento para ello.
                    </li>
                  </ol>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong
                      >5. An&aacute;lisis de usabilidad y de calidad para la
                      mejora de nuestros servicios
                    </strong>
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Si accedes a nuestra Web, te informamos de que trataremos
                    tus datos de navegaci&oacute;n para fines anal&iacute;ticos
                    y estad&iacute;sticos, es decir, para entender la forma en
                    la que los usuarios interact&uacute;an con nuestra Web y con
                    las acciones que podemos llevar a cabo en otros sitios web y
                    apps y as&iacute; ser capaces de introducir mejoras.
                    As&iacute; mismo, en ocasiones realizamos acciones y
                    encuestas de calidad destinadas a conocer el grado de
                    satisfacci&oacute;n de nuestros clientes y usuarios y
                    detectar aquellas &aacute;reas en las que podemos mejorar.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong class="fontBold"
              >3. &iquest;CU&Aacute;L ES LA LEGITIMACI&Oacute;N PARA EL
              TRATAMIENTO DE TUS DATOS?</strong
            >
          </p>
          <p class="fontBook" style="padding-left: 40px">
            La base legal que nos permite tratar tus datos personales
            tambi&eacute;n depende de la finalidad para la que los tratemos,
            seg&uacute;n lo explicado en la siguiente tabla:
          </p>
          <table border="">
            <tbody>
              <tr>
                <td>
                  <p class="textoCentradoModal">
                    <strong class="fontBold">FINALIDAD</strong>
                  </p>
                </td>
                <td>
                  <p class="textoCentradoModal">
                    <strong class="fontBold">LEGITIMACI&Oacute;N</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold"
                      >1. Gestionar tu registro como usuario de la Web</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    El tratamiento de tus datos es necesario para la
                    ejecuci&oacute;n de los t&eacute;rminos que regulan el uso
                    de la Web. En otras palabras, para que puedas registrarte
                    como usuario en la Web, necesitamos tratar tus datos
                    personales, ya que de lo contrario no podr&iacute;amos
                    gestionar tu registro. Consideramos que tenemos un
                    inter&eacute;s leg&iacute;timo para vincular a tu cuenta tus
                    compras y los datos que recopilamos sobre tu actividad a
                    trav&eacute;s de los diferentes canales de la Web
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong
                      >2. Desarrollo, cumplimiento y ejecuci&oacute;n del
                      contrato de servicios</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    El tratamiento de tus datos es necesario para la
                    ejecuci&oacute;n del contrato de prestaci&oacute;n de
                    servicios que nos vincule contigo. En estos casos, la base
                    sobre la que tratamos tus datos es tu propio consentimiento.
                    Adem&aacute;s, tratamos tus datos de localizaci&oacute;n
                    cuando nos das tu consentimiento, para ofrecerte servicios
                    espec&iacute;ficos a trav&eacute;s de la Web cuando visitas
                    algunas de nuestras p&aacute;ginas. Consideramos que tenemos
                    un inter&eacute;s leg&iacute;timo para realizar las
                    comprobaciones necesarias para detectar y prevenir posibles
                    fraudes o usos fraudulentos cuando usas la Web, por ejemplo,
                    al realizar una compra o devoluci&oacute;n. Entendemos que
                    el tratamiento de estos datos resulta positivo para todas
                    las partes: para ti, ya que nos permite poner medidas para
                    protegerte contra intentos de fraude realizados por
                    terceros; para Nosotros, porque nos permite evitar que se
                    haga un uso indebido de la Web; para todos nuestros clientes
                    y la sociedad, porque tambi&eacute;n protege su
                    inter&eacute;s en asegurar que las actividades fraudulentas
                    sean desalentadas y detectadas cuando ocurran.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold"
                      >3. Atenci&oacute;n al Cliente</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Consideramos que tenemos un inter&eacute;s leg&iacute;timo
                    para atender las solicitudes o consultas que nos plantees a
                    trav&eacute;s de los diversos medios de contacto existentes.
                    Entendemos que el tratamiento de estos datos resulta
                    tambi&eacute;n beneficioso para ti en tanto que nos permite
                    poder atenderte adecuadamente y resolver las consultas
                    planteadas. Cuando nos contactes, en particular, para la
                    gesti&oacute;n de incidencias relacionadas con tu curso o el
                    producto/ servicio adquirido a trav&eacute;s de la Web, el
                    tratamiento es necesario para la ejecuci&oacute;n del
                    contrato de compraventa. Cuando tu consulta est&eacute;
                    relacionada con el ejercicio de los derechos sobre los que
                    te informamos m&aacute;s abajo, o con reclamaciones
                    relacionadas con nuestros productos o servicios, lo que nos
                    legitima para tratar tus datos es el cumplimiento de
                    obligaciones legales por nuestra parte
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold">4. Marketing</strong>
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    . La base leg&iacute;tima para tratar tus datos con
                    finalidades de marketing es el consentimiento que nos
                    prestas, por ejemplo: cuando aceptas recibir
                    informaci&oacute;n personalizada a trav&eacute;s de diversos
                    medios, cuando prestas tu consentimiento mediante la
                    configuraci&oacute;n de las cookies o de la privacidad de tu
                    dispositivo, o cuando aceptas las bases legales para
                    participar en una acci&oacute;n promocional o para publicar
                    tus fotograf&iacute;as en la Web o en nuestros canales de
                    redes sociales. Para ofrecerte servicios personalizados o
                    mostrarte informaci&oacute;n personalizada, ya sea en
                    nuestra Web o en la de terceros, as&iacute; como para llevar
                    a cabo el enriquecimiento de datos, consideramos que tenemos
                    un inter&eacute;s leg&iacute;timo para realizar un perfilado
                    con la informaci&oacute;n que tenemos sobre ti (como la
                    navegaci&oacute;n que realizas, preferencias o
                    hist&oacute;rico de cursos) y los datos personales que nos
                    has facilitado como rango de edad o idioma, ya que
                    entendemos que el tratamiento de estos datos tambi&eacute;n
                    resulta beneficioso para ti porque te permite mejorar tu
                    experiencia como usuario y acceder a informaci&oacute;n de
                    acuerdo con tus preferencias.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold"
                      >5. An&aacute;lisis de usabilidad y de calidad</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Consideramos que tenemos un inter&eacute;s leg&iacute;timo
                    para analizar la usabilidad de la Web y el grado de
                    satisfacci&oacute;n del usuario ya que entendemos que el
                    tratamiento de estos datos tambi&eacute;n resulta
                    beneficioso para ti porque la finalidad es mejorar la
                    experiencia del usuario y ofrecer un servicio de mayor
                    calidad.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong class="fontBold"
              >4. &iquest;DURANTE CU&Aacute;NTO TIEMPO CONSERVAREMOS TUS DATOS?
            </strong>
          </p>
          <p class="fontBook" style="padding-left: 40px">
            El plazo de conservaci&oacute;n de tus datos depender&aacute; de las
            finalidades para las que los tratemos, seg&uacute;n lo explicado a
            continuaci&oacute;n:
          </p>
          <table border="">
            <tbody>
              <tr>
                <td>
                  <p class="textoCentradoModal">
                    <strong class="fontBold">FINALIDAD</strong>
                  </p>
                </td>
                <td>
                  <p class="textoCentradoModal">
                    <strong class="fontBold"
                      >PLAZO DE CONSERVACI&Oacute;N</strong
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold"
                      >1. Gestionar tu registro como usuario de la Web</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Trataremos tus datos durante el tiempo en que mantengas la
                    condici&oacute;n de usuario registrado (es decir, hasta que
                    finalice el servicio contratado o quieras cancelarlo).
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong
                      >2. Desarrollo, cumplimiento y ejecuci&oacute;n del
                      contrato de compraventa o servicios</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Trataremos tus datos durante el tiempo necesario para
                    gestionar la contrataci&oacute;n de servicios que hayas
                    adquirido, incluyendo posibles quejas o reclamaciones
                    asociadas a la contrataci&oacute;n del servicio en
                    particular. En algunas ocasiones, &uacute;nicamente
                    trataremos los datos hasta el momento en que t&uacute;
                    decidas.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold"
                      >3. Atenci&oacute;n al Cliente</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Trataremos tus datos durante el tiempo que sea necesario
                    para atender tu solicitud o petici&oacute;n.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold">4. Marketing</strong>
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Trataremos tus datos hasta que te des de baja o canceles tu
                    suscripci&oacute;n a la newsletter. Asimismo, te mostraremos
                    anuncios personalizados hasta que cambies el dispositivo, el
                    navegador o la configuraci&oacute;n de las cookies, lo que
                    revocar&aacute; dicho permiso. Si participas en acciones
                    promocionales conservaremos tus datos por un plazo de seis
                    (6) meses desde que finalice la acci&oacute;n.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="fontBook">
                    <strong class="fontBold"
                      >5. An&aacute;lisis de usabilidad y de calidad</strong
                    >
                  </p>
                </td>
                <td>
                  <p class="fontBook">
                    Trataremos tus datos puntualmente durante el tiempo en el
                    que procedamos a realizar una acci&oacute;n o encuesta de
                    calidad concreta o hasta que anonimicemos tus datos de
                    navegaci&oacute;n.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="fontBook" style="padding-left: 40px">
            &nbsp;Independientemente de que tratemos tus datos durante el tiempo
            estrictamente necesario para cumplir con la finalidad
            correspondiente, los conservaremos posteriormente debidamente
            guardados y protegidos durante el tiempo en que pudieran surgir
            responsabilidades derivadas del tratamiento, en cumplimiento con la
            normativa vigente en cada momento. Una vez prescriban las posibles
            acciones en cada caso, procederemos a la supresi&oacute;n de los
            datos personales.
          </p>
          <p>
            <strong class="fontBold"
              >5. &iquest;COMPARTIREMOS TUS DATOS CON TERCEROS?
            </strong>
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Para cumplir las finalidades indicadas en la presente
            Pol&iacute;tica de Privacidad y Cookies, es necesario que demos
            acceso a tus datos personales a entidades del Grupo AE y a terceras
            partes que nos presten apoyo en los servicios que te ofrecemos, a
            saber:
          </p>
          <ol>
            <li style="list-style-type: none">
              <ol class="lista">
                <li class="fontBook">Universidades,</li>
                <li class="fontBook">entidades de formaci&oacute;n,</li>
                <li class="fontBook">entidades financieras,</li>
                <li class="fontBook">
                  entidades de detecci&oacute;n y prevenci&oacute;n de fraude,
                </li>
                <li class="fontBook">
                  proveedores de servicios tecnol&oacute;gicos y
                  anal&iacute;tica,
                </li>
                <li class="fontBook">
                  proveedores de servicios relacionados con atenci&oacute;n al
                  cliente,
                </li>
                <li class="fontBook">
                  proveedores y colaboradores de servicios relacionados con
                  marketing y publicidad, como agencias de publicidad, socios
                  publicitarios o redes sociales que, en determinados casos,
                  puedan actuar como controladores conjuntos.
                </li>
              </ol>
            </li>
          </ol>
          <p class="fontBook" style="padding-left: 40px">
            Por eficiencia del servicio, algunos de los prestadores mencionados
            est&aacute;n ubicados en territorios situados fuera del Espacio
            Econ&oacute;mico Europeo que no proporcionan un nivel de
            protecci&oacute;n de datos equiparable al de la Uni&oacute;n
            Europea. En tales casos, te informamos de que transferimos tus datos
            con garant&iacute;as adecuadas y siempre manteniendo la seguridad de
            tus datos, ya que utilizamos las herramientas m&aacute;s apropiadas
            para la transferencia internacional de datos, como las
            Cl&aacute;usulas Contractuales Tipo o cualquier otra medida
            complementaria pertinente. Puedes consultar el contenido de las
            Cl&aacute;usulas Contractuales Tipo en el siguiente enlace:
            <a class="enlace"
              href="https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transferpersonal-data-third-countries_en"
              >https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transferpersonal-data-third-countries_en.
            </a>
          </p>
          <p class="fontBook" style="padding-left: 40px">
            En el caso de que transfiri&eacute;ramos la totalidad o una parte de
            nuestro negocio o nuestros activos a otra empresa perteneciente o no
            al Grupo AE, o desempe&ntilde;&aacute;ramos cualquier otra actividad
            comercial como consecuencia de una reorganizaci&oacute;n
            corporativa, podr&iacute;amos revelar tus datos personales al
            potencial receptor del negocio o los activos. En el caso de
            producirse dicha venta o transferencia, realizar&iacute;amos los
            esfuerzos razonables para que el beneficiario tratara la
            informaci&oacute;n personal que nos has facilitado conforme a
            nuestra Pol&iacute;tica de Privacidad. En este caso, consideramos
            que tenemos un inter&eacute;s leg&iacute;timo basado en la
            reorganizaci&oacute;n de nuestra estructura corporativa.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Por otra parte, si decides utilizar la Web en diferentes mercados
            (es decir, creando cuentas de usuario registrado en distintos
            mercados con la misma direcci&oacute;n de correo
            electr&oacute;nico), podr&iacute;amos necesitar revelar o transferir
            la informaci&oacute;n vinculada a tu cuenta o a tu actividad a las
            empresas de la marca que operen en dichos mercados, en la medida en
            que est&eacute;n directamente implicadas en la consecuci&oacute;n de
            cualquier de los objetivos descritos en la secci&oacute;n 2.
            Consideramos esto necesario para satisfacer nuestros mutuos
            intereses y preferencias.
          </p>
          <p>
            <strong class="fontBold"
              >6. &iquest;CU&Aacute;LES SON TUS DERECHOS CUANDO NOS FACILITAS
              TUS DATOS?
            </strong>
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Nos comprometemos a respetar la confidencialidad de tus datos
            personales y a garantizarte el ejercicio de tus derechos. Los
            Corresponsables hemos acordado que puedes ejercitarlos sin coste
            alguno escribi&eacute;ndonos un correo electr&oacute;nico a una
            direcci&oacute;n de correo &uacute;nica
            <a class="enlace" href="mailto:info@alebateducation.com"
              >info@alebateducation.com</a
            >, simplemente indic&aacute;ndonos el motivo de tu solicitud y el
            derecho que quieres ejercitar. En caso de que lo consideremos
            necesario para poder identificarte, podremos solicitarte copia de un
            documento acreditativo de tu identidad.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Asimismo, podemos ofrecerte la posibilidad de ejercer tus derechos y
            configurar tus preferencias de privacidad al utilizar algunos de
            nuestros servicios o poniendo a tu disposici&oacute;n canales
            espec&iacute;ficos dentro de nuestra Web.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            En particular, independientemente de la finalidad o la base legal en
            virtud de la que tratemos tus datos, tienes derecho a:
          </p>
          <ul>
            <li style="list-style-type: none">
              <ul>
                <li class="fontBook">
                  Pedirnos acceso a los datos de los que disponemos de ti. Te
                  recordamos que en caso de ser usuario registrado en la Web
                  tambi&eacute;n puedes consultar esta informaci&oacute;n en la
                  secci&oacute;n correspondiente a tus datos personales.
                </li>
                <li class="fontBook">
                  Pedirnos que rectifiquemos los datos de los que ya disponemos.
                  Recuerda que si eres usuario registrado en la Web
                  tambi&eacute;n puedes acceder a la secci&oacute;n
                  correspondiente a tus datos personales de tu cuenta de para
                  modificar o actualizar tus datos personales. De todas formas,
                  ten en cuenta que, al facilitarnos activamente tus datos
                  personales por cualquier v&iacute;a, garantizas que son
                  ciertos y exactos y te comprometes a notificarnos cualquier
                  cambio o modificaci&oacute;n de los mismos. Cualquier
                  p&eacute;rdida o da&ntilde;o causado a la Web o al responsable
                  de la Web o a cualquier tercero por motivo de una
                  comunicaci&oacute;n de informaci&oacute;n err&oacute;nea,
                  inexacta o incompleta en los formularios de registro,
                  ser&aacute; responsabilidad exclusiva del usuario. Por favor,
                  recuerda que por regla general solo debes facilitarnos tus
                  propios datos personales, no los de terceros, salvo en lo
                  permitido en esta Pol&iacute;tica de Privacidad y Cookies.
                </li>
                <li class="fontBook">
                  Pedirnos que Suprimamos tus datos en la medida en que ya no
                  sean necesarios para la finalidad para los que necesitemos
                  tratarlos seg&uacute;n te hemos informado m&aacute;s arriba, o
                  en que ya no contemos con legitimaci&oacute;n para hacerlo.
                </li>
                <li class="fontBook">
                  Pedirnos que limitemos el tratamiento de tus datos, lo que
                  supone que en determinados casos puedas solicitarnos que
                  suspendamos temporalmente el tratamiento de los datos o que
                  los conservemos m&aacute;s all&aacute; del tiempo necesario
                  cuando puedas necesitarlo.
                </li>
              </ul>
            </li>
          </ul>
          <p class="fontBook" style="padding-left: 40px">
            Si nos has proporcionado tu consentimiento para el tratamiento de
            tus datos para cualquier finalidad, tambi&eacute;n tienes derecho a
            retirarlo en cualquier momento. Algunas de las formas en las que
            puedes retirar tu consentimiento est&aacute;n explicadas en el
            apartado 2 en el que explicamos para qu&eacute; finalidades tratamos
            tus datos.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            En el caso de que no quieras que se env&iacute;e informaci&oacute;n
            a terceros para mostrarte anuncios, dispones de varios medios, como
            cambiar las preferencias en el dispositivo, el navegador o la
            configuraci&oacute;n de las cookies, revisar la pol&iacute;tica de
            privacidad y la configuraci&oacute;n de las redes sociales en las
            que tengas perfil o enviarnos un correo electr&oacute;nico con tu
            solicitud a la direcci&oacute;n anteriormente mencionada.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Cuando nuestra legitimaci&oacute;n para el tratamiento de tus datos
            sea tu consentimiento o la ejecuci&oacute;n del contrato,
            seg&uacute;n lo explicado en el apartado 3, tambi&eacute;n
            tendr&aacute;s derecho a solicitar la portabilidad de tus datos
            personales. Esto significa que tendr&aacute;s derecho a recibir los
            datos personales que nos hayas facilitado en un formato
            estructurado, de uso com&uacute;n y legible por una m&aacute;quina,
            para poder transmitirlo a otra entidad directamente, siempre que
            t&eacute;cnicamente sea posible.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Por otra parte, cuando el tratamiento de tus datos est&eacute;
            basado en nuestro inter&eacute;s leg&iacute;timo, tambi&eacute;n
            tendr&aacute;s derecho a oponerte al tratamiento de tus datos.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Por &uacute;ltimo, te informamos de tu derecho a presentar una
            reclamaci&oacute;n ante la autoridad de control en materia de
            protecci&oacute;n de datos pertinente, en particular, ante la
            Agencia Espa&ntilde;ola de Protecci&oacute;n de Datos (<a class="enlace"
              href="https://www.agpd.es/portalwebAGPD/index-ides-idphp.php)"
              >https://www.agpd.es/portalwebAGPD/index-ides-idphp.php).
            </a>
          </p>
          <p>
            <strong class="fontBold"
              >7. &iquest;QU&Eacute; PASA SI NOS FACILITAS DATOS DE TERCEROS O
              SI UN TERCERO NOS HA FACILITADO DATOS TUYOS?
            </strong>
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Ofrecemos funcionalidades o servicios que requieren que tratemos los
            datos personales de un tercero que t&uacute; como usuario o cliente
            nos facilites. Si nos proporcionas Datos Personales de terceras
            personas o si resulta necesario que nos los faciliten con motivo de
            la recogida de un tercero de un pedido a tu nombre, garantizas
            haberles informado acerca de las finalidades y la forma en la que
            necesitamos tratar sus datos personales.
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Si un tercero nos ha facilitado tus datos o los has aportado
            t&uacute; mismo como consecuencia de una funcionalidad o servicio
            solicitado por uno de nuestros usuarios, los usaremos para gestionar
            la funcionalidad o servicio que se est&eacute; desarrollando en cada
            caso, dentro de las finalidades recogidas en esta Pol&iacute;tica de
            Privacidad y Cookies, cuyo enlace incluimos habitualmente en
            nuestras comunicaciones.
          </p>
          <p>
            <strong class="fontBold"
              >8. CAMBIOS A LA POL&Iacute;TICA DE PRIVACIDAD Y COOKIES
            </strong>
          </p>
          <p class="fontBook" style="padding-left: 40px">
            &nbsp;Es posible que modifiquemos la informaci&oacute;n contenida en
            esta Pol&iacute;tica de Privacidad y Cookies cuando lo estimemos
            conveniente. En caso de que lo hagamos, te lo notificaremos por
            distintas v&iacute;as a trav&eacute;s de la Web (por ejemplo, a
            trav&eacute;s de un banner, un pop-up o una notificaci&oacute;n
            push), o incluso te lo comunicaremos a tu direcci&oacute;n de correo
            electr&oacute;nico cuando el cambio en cuesti&oacute;n sea
            significativo para con tu privacidad, de manera que puedas revisar
            los cambios, valorarlos y, en su caso, oponerte o darte de baja en
            alg&uacute;n servicio o funcionalidad. En cualquier caso, te
            sugerimos que revises esta Pol&iacute;tica de Privacidad y Cookies
            de vez en cuando por si hubiera cambios menores o introducimos
            alguna mejora interactiva, aprovechando que siempre la
            encontrar&aacute;s como punto permanente de informaci&oacute;n en
            nuestra Web y nuestra App.
          </p>
          <p>
            <strong class="fontBold"
              >9. INFORMACI&Oacute;N SOBRE COOKIES</strong
            >
          </p>
          <p class="fontBook" style="padding-left: 40px">
            Utilizamos cookies y dispositivos similares para facilitar tu
            navegaci&oacute;n en la Web, conocer c&oacute;mo interact&uacute;as
            con Nosotros y, en determinados casos, poder mostrarte publicidad en
            funci&oacute;n de tus h&aacute;bitos de navegaci&oacute;n. Por
            favor, lee nuestra Pol&iacute;tica de Cookies para conocer con mayor
            detalle las cookies y dispositivos similares que usamos, su
            finalidad y c&oacute;mo gestionar tus preferencias, as&iacute; como
            otra informaci&oacute;n de inter&eacute;s.
          </p>
        </div>
        <!--divVerMas-->
      </div>
      <!--divModalInterno-->
    </div>
    <!--Privacidad-->
  </section>
</template>

<script>
export default {
  name: "PoliticaDePrivacidadPrincipal",
};
</script>